import VendorsFancybox      from './fancybox/fancybox';
import VendorsFlatpickr from "../../default/vendors/flatpickr/flatpickr";
import VendorsBootstrap from "../../default/vendors/bootstrap/bootstrap";
import VendorsMobiscroll from "../../default/vendors/mobiscroll/js/mobiscroll-dummy";

const vendors = () => {
	/* eslint-disable no-console */
	// if (processEnv === 'development') {
	// 	console.log('Vendors');
	// }
	/* eslint-enable no-console */

	VendorsFancybox();
	VendorsFlatpickr.init();
	VendorsBootstrap.init();
	VendorsMobiscroll();
};

export default vendors;
